import React, { useState } from 'react';
import { UloadFilterSectionProps, UserUloadDetailsObject } from '../interfaces';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styles from './UloadFilterSection.module.css';
import { writeDataToExcel } from '../apiCalls';
const UloadFilterSection: React.FC<UloadFilterSectionProps> = (
  props: UloadFilterSectionProps
) => {
  const [curSelectedUload, setCurSelectedUload] = useState('');

  const updateFilter = () => {
    if (curSelectedUload) {
      if (curSelectedUload !== 'Select Uload') {
        const fetchData = async () => {
          try {
            const userDataResponse = await writeDataToExcel(curSelectedUload);
            const blob = new Blob([userDataResponse], {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `${curSelectedUload.split('.')[1]}_Template.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          } catch (e) {
            console.log('Error downloading the file', e);
          }
        };
        fetchData();
      }
    }
  };

  return (
    <Container className='ml-auto mt-2' fluid>
      <Row>
        <Col className='m-auto' sm>
          <label className={styles.inputLabels}>Select Uload</label>
          <select
            aria-label='uload'
            className='form-control'
            onChange={(event) => {
              setCurSelectedUload(event.target.value);
              props.setCurrentFilters(event.target.value);
            }}
            value={curSelectedUload}
          >
            <option>Select Uload</option>
            {props.userData.map(
              (item: UserUloadDetailsObject, index: number) => (
                <option value={item.USER_ACCESS} key={index}>
                  {item.USER_ACCESS}
                </option>
              )
            )}
          </select>
        </Col>

        <Col className='m-auto' md={2}>
          <Button
            className={styles.searchButton}
            variant='primary'
            onClick={updateFilter}
          >
            Download Templete
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default UloadFilterSection;
